import * as React from 'react';

import {GraphQLSelectAccountTypes} from '../../../core/select/graphql-select-account-types';

export const ACCOUNT_TYPE_SELECT_ID = 'account-type-select';

type Props = {
    accountTypeId: string | null | undefined;
    onUpdateAccountType: (accountTypeId: string) => void;
    isDisabled?: boolean;
    canAccessSetup: boolean;
};

export function AccountTypeSelect(props: Props) {
    const {accountTypeId, onUpdateAccountType, canAccessSetup} = props;

    // All accounts have to have an account type, so if we don't have one,
    // something went wrong and this needs to be disabled.
    const isDisabled = !accountTypeId || props.isDisabled;

    // @ts-expect-error
    const onChangeAccountType = (selectedAccountType) => {
        if (isDisabled) return;

        if (selectedAccountType && selectedAccountType.id) {
            onUpdateAccountType(selectedAccountType.id);
        }
    };

    return (
        <GraphQLSelectAccountTypes
            inputId={ACCOUNT_TYPE_SELECT_ID}
            selectedId={accountTypeId}
            onChange={onChangeAccountType}
            useDefaultPlaceholder={true}
            autoFocus={false}
            hasManageOption={canAccessSetup}
            // @ts-expect-error
            isDisabled={isDisabled}
        />
    );
}
